import { useQuery } from '@tanstack/react-query';

import type { SellerPeriodValue } from '../lib/sellerFormat';
import { sellerDashboardApi } from '../services/sellerDashboardApi';

/**
 * Prefixo invalidado pelo `useLeadCaptureSocket` global (Parte 2) a cada
 * evento `LEAD_CAPTURE_SESSION_UPDATED` — ver
 * `src/shared/hooks/useLeadCaptureSocket.ts` (`invalidateQueries({ queryKey: ['seller-dashboard'] })`).
 */
export const SELLER_DASHBOARD_QUERY_KEY = 'seller-dashboard';

/**
 * Chave da query: `['seller-dashboard', modo]` nos prontos e
 * `['seller-dashboard', 'custom', início, fim]` no personalizado — sempre sob o
 * prefixo invalidado pela captura.
 */
export const sellerDashboardQueryKey = (period: SellerPeriodValue): ReadonlyArray<string | undefined> =>
  period.mode === 'custom'
    ? [SELLER_DASHBOARD_QUERY_KEY, period.mode, period.start, period.end]
    : [SELLER_DASHBOARD_QUERY_KEY, period.mode];

/** Dashboard do vendedor (`GET /api/leads/seller-dashboard`) — cache de 60s no backend, staleTime 30s no client. */
export const useSellerDashboard = (period: SellerPeriodValue) =>
  useQuery({
    queryKey: sellerDashboardQueryKey(period),
    queryFn: () => sellerDashboardApi.get(period),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
